import { hideCurrentModal } from '../globalState';
import { useIsModalActive } from './utilsApp';
import Screen from './Screen';
import PixelartIcon, { pixelartIcons } from './PixelartIcon';
import styles from './CreditsAboutModal.module.css';
export default () => {
    const isModalActive = useIsModalActive('credits-about');
    if (!isModalActive)
        return null;
    return (<Screen title="" backdrop className={styles.modalScreen}>
      <div className={styles.container}>
        <h2 className={styles.title}>Minecraft</h2>

        <div className={styles.contentWrapper}>
          <p className={styles.paragraph}>
            This client makes use of the following third-party projects:
          </p>
          <ul className={styles.list}>
            <li className={styles.listItem}>- <span><a className={styles.link} href="https://viaversion.com/" target="_blank" rel="noopener noreferrer">[ViaVersion]</a></span> for providing reliable sound id mappings</li>
            <li className={styles.listItem}>- <span><a className={styles.link} href="https://github.com/BlueMap-Minecraft/BlueMap" target="_blank" rel="noopener noreferrer">[Bluemap]</a></span> for providing block entity models like chest</li>
            <li className={styles.listItem}>- <span><a className={styles.link} href="https://github.com/misode/deepslate" target="_blank" rel="noopener noreferrer">[Deepslate]</a></span> for rendering 3d blocks in GUI (inventory)</li>
            <li className={styles.listItem}>- <span><a className={styles.link} href="https://www.npmjs.com/package/skinview3d" target="_blank" rel="noopener noreferrer">[skinview3d]</a></span> for rendering skins & player geometry</li>
            <li className={styles.listItem}>- <span><a className={styles.link} href="https://github.com/atxi/Polymer" target="_blank" rel="noopener noreferrer">[Polymer]</a></span> (c++ project) for providing fast & accurate server light implementation</li>
          </ul>

          <button className={styles.closeButton} onClick={() => hideCurrentModal()} aria-label="Close" type="button">
            <PixelartIcon iconName={pixelartIcons.close} width={12} className={styles.closeIcon}/>
          </button>
        </div>
      </div>
    </Screen>);
};
